import {
    genericBladeSagas, loanPurposeSagas,
} from '@commblades/commblades';
import { all, call, spawn } from 'redux-saga/effects';

import { navigationWatchSaga } from '../app/navigation/navigationSaga';
import { debtConsolidationWatchSaga } from '../app/navigation/blades/debtConsolidation/debtConsolidationSaga';
import { borrowingInputWatchSaga } from '../app/navigation/blades/borrowingInput/borrowingInputSaga';

export default function* rootSaga() {
    const sagas = [
        ...genericBladeSagas,
        ...navigationWatchSaga,
        ...loanPurposeSagas,
        ...debtConsolidationWatchSaga,
        ...borrowingInputWatchSaga,
    ];

    yield all(sagas.map((saga) => spawn(function* () {
        // eslint-disable-next-line no-unreachable-loop
        while (true) {
            yield call(saga);
            break;
        }
    })));
}
